import { Box, Paper, Typography } from '@mui/material'
import { LineChart } from '@mui/x-charts/LineChart'
import { format } from 'date-fns'
import { ProcessedChart } from '../StatisticCharts'

const ChartCard = ({ chart }: { chart: ProcessedChart }) => (
  <Paper
    sx={{
      p: '16px',
      py: '8px',
      boxShadow: '0px 2px 10px 2px rgba(0, 0, 0, 0.1)',
      borderRadius: '4px',
      border: '1px solid rgba(0, 0, 0, 0.12)',
      height: '400px',
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    <Typography sx={{ mb: '16px', fontWeight: 500 }}>{chart.title}</Typography>
    <Box sx={{ flex: 1, minHeight: 0 }}>
      {chart.series.length > 0 && chart.xAxis.data.length > 0 ? (
        <LineChart
          series={chart.series}
          xAxis={[
            {
              data: chart.xAxis.data,
              scaleType: 'time',
              valueFormatter: (value) => format(new Date(value), 'yyyy-MM-dd HH:mm:ss'),
            },
          ]}
          slotProps={{ legend: { hidden: true }}}
          margin={{ left: 70, right: 20, top: 20, bottom: 40 }}
          height={350}
        />
      ) : (
        <Box
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}
        >
          <Typography color="text.secondary">No data available</Typography>
        </Box>
      )}
    </Box>
  </Paper>
)
export default ChartCard